<template>
  <div class="tw-flex tw-flex-col tw-p-12">
    <p class="tw-text-2xl tw-pb-7">
      Benchmark Name
    </p>
    <o-field>
      <o-input v-model="name" />
    </o-field>
    <p class="tw-text-2xl tw-pb-7">
      Add Holdings To Benchmark
    </p>
    <div
      v-for="(selected, index) in selectedItems"
      :key="selected.id"
      class="tw-flex tw-justify-between tw-items-center"
    >
      <button
        class="tw-text-red-500 tw-w-6 tw-h-6 tw-rounded-full tw-border tw-border-red-500 tw-hover:text-white tw-hover:bg-red-500 tw-transition tw-duration-300 tw-flex tw-items-center tw-justify-center"
        @click.prevent="removeHolding(index)"
      >
        -
      </button>
      <div class="tw-flex-grow tw-ml-4">
        <div>
          {{ selected.symbol }}
        </div>
        <div>
          {{ selected.full_name }}
        </div>
      </div>
      <div class="tw-ml-7">
        <o-field label="Percentage">
          <o-input
            v-model="selected.percentage"
            class="inline-input"
            type="number"
            min="0"
            max="100"
          /> %
        </o-field>
      </div>
    </div>
    <o-field v-if="showSearchBox">
      <o-autocomplete
        v-model="search"
        :placeholder="searchPlaceholder"
        field="display"
        :data="searchResults"
        icon-pack="fa"
        :icon-right="isLoading ? 'fa fa-spinner fa-spin' : ''"
        @input="debouncedGetSearchResults"
        @select="selectOption"
      >
        <!-- Custom slot for showing symbol and full name -->
        <template v-slot="{ option }">
          <div class="media-content">
            <strong>{{ option.ticker.symbol }}</strong>
            <br>
            <span class="tw-text-sm tw-text-gray-600">{{ option.ticker.full_name }}</span>
          </div>
        </template>
      </o-autocomplete>
    </o-field>
    <a
      href="#"
      @click.prevent="addAnotherTicker"
    >+ Add Another</a>
    <div class="tw-sticky tw-w-full tw-bottom-0 tw-right-0 tw-flex tw-pt-7 tw-justify-end">
      <o-button
        variant="primary"
        :disabled="!canSubmit"
        class="tw-py-2 tw-px-4 tw-rounded"
        @click="createPortfolio"
      >
        Submit
      </o-button>
    </div>
    <p
      v-if="!isValidTotalPercent"
      class="tw-text-right tw-text-red-400 tw-pb-2"
    >
      Your percentages cannot total more than 100% or less than 0%
    </p>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'PortfolioCreator',
  data() {
    return {
      name: '',
      search: '',
      searchResults: [],
      selectedItems: [],
      isLoading: false,
      searchPlaceholder: 'Search for a ticker symbol e.g. ACWI',
      showSearchBox: true,
    };
  },
  methods: {
    removeHolding(index) {
      this.selectedItems.splice(index, 1);
    },
    async createPortfolio() {
      const url = '/api/v1/portfolios/';
      const req = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.$root.$data.csrfToken,
        },
        body: JSON.stringify({
          'name': this.name,
          'return_entity': true,
          'holdings': this.selectedItems.map((itm) => {
            return {
              'identifier': itm.id,
              'identifier_type': 'ticker_id',
              'percentage': itm.percentage / 100,
            };
          }),
        }),
      });
      if (req.ok) {
        const data = await req.json();
        console.log('Created portfolio', data);
        this.$emit('submit', data);
      } else {
        console.error('Error creating portfolio');
      }
    },
    addAnotherTicker() {
      this.search = '';
      this.searchPlaceholder = 'Search for another ticker';
      this.showSearchBox = true;
    },
    async getSearchResults() {
      this.isLoading = true;
      try {
        const searchurl = '/api/v1/tickers/?search=$' + this.search
        const response = await fetch(searchurl);
        const data = await response.json();
        // Add 'display' property for autocomplete to use both symbol and full name
        this.searchResults = data.tickers.map(result => ({
          ...result,
          display: `${result.ticker.symbol} - ${result.ticker.full_name}`
        }));
      } catch (error) {
        console.error(error);
      }
      this.isLoading = false;
    },
    debouncedGetSearchResults: debounce(function() {
      this.getSearchResults();
    }, 200),
    selectOption(option) {
      if (!option) return;
      this.selectedItems = [...this.selectedItems, option.ticker];
      this.showSearchBox = false;
    },
  },
  computed: {
    isValidTotalPercent() {
      const totalPercentage = this.selectedItems.reduce((total, item) => total + Number(item.percentage), 0);
      return totalPercentage <= 100 && totalPercentage > 0;
    },
    canSubmit() {
      if (!this.name || this.selectedItems.length === 0) {
        return false;
      }
      return this.isValidTotalPercent;
    },
  },
};
</script>

<style scoped>
.inline-input {
  display: inline-block;
}
</style>
